import nl from '../../translation/nl_NL'

export default {
  // i18nConfiguration
  i18n: {
    locales: [
      {
        code: 'nl',
        iso: 'nl-NL',
      },
    ],
    defaultLocale: 'nl',
    vueI18n: {
      fallbackLocale: 'nl',
      messages: {
        nl,
      },
    },
    pages: {
      'categories/business': {
        nl: '/business',
      },
      'categories/get-inspired': {
        nl: '/laat-je-inspireren',
      },
      'categories/how-to': {
        nl: '/hoe-het-moet',
      },
      'categories/news': {
        nl: '/nieuws',
      },
      'categories/printstories': {
        nl: '/printstories',
      },
      'editorial-staff/index': {
        nl: '/redactie',
      },
      'editorial-staff/_author': {
        nl: '/redactie/:author?',
      },
    },
  },
  /* 
    Categories Configuration
    @order: [] è l'array delle chiavi delle categorie e rappresenta l'ordine con cui verranno visualizzate le categorie dove richieste
    list{
        @key è la chiave della categoria. Per convenzione chiamata come il folder dentro page.
        {
          @slug è lo slug della categoria inserito in categorie su Wordpress
          @view è la view di nuxt e corrisponde al name utilizzato nei nuxt-link
        }
    }
  */
  pages: {
    // leggere README.md
    list: [
      {
        key: 'index', // Home per comodità la trattiamo come una categoria
        wpUri: '/',
      },
      {
        key: 'business',
        wpUri: '/business/',
      },
      {
        key: 'get-inspired',
        wpUri: '/laat-je-inspireren/',
      },
      {
        key: 'how-to',
        wpUri: '/hoe-het-moet/',
      },
      {
        key: 'news',
        wpUri: '/nieuws/',
      },
      {
        key: 'printstories',
        wpUri: '/printstories/',
      },
      {
        key: 'editorial-staff',
        wpUri: '/redactie/',
      },
    ],
  },
  categories: {
    // leggere README.md
    list: [
      {
        key: 'business',
        wpSlug: 'business',
        view: 'categories-business',
        wpCategoryId: 4096,
      },
      {
        key: 'get-inspired',
        wpSlug: 'lasciatiispirare',
        view: 'categories-get-inspired',
        wpCategoryId: 69,
      },
      {
        key: 'how-to',
        wpSlug: 'comesifa',
        view: 'categories-how-to',
        wpCategoryId: 67,
      },
      {
        key: 'news',
        wpSlug: 'lenovita',
        view: 'categories-news',
        wpCategoryId: 70,
      },
      {
        key: 'printstories',
        wpSlug: 'printstories',
        view: 'categories-printstories',
        wpCategoryId: 6980,
      },
      {
        key: 'highlights',
        wpSlug: 'highlights',
        view: null,
        wpCategoryId: 6979,
      },
      {
        key: 'business-growth',
        wpSlug: 'businessgrowth',
        view: null,
        wpCategoryId: 6978,
      },
    ],
  },
  pixartWebsite: 'https://www.pixartprinting.it/',
  navigation: {
    primary: {
      // TODO: Per rivisualizzare nel menu le categorie commentate basta togliere il commento.
      order: [
        'business',
        /* 'printstories', */ 'how-to',
        'get-inspired' /* 'news' */,
      ],
    },
    // Categorie che vengono filtrate da eventuali elenchi (es. la lista delle categorie a cui appartiene un post)
    exclude: ['highlights', 'business-growth'],
  },
  social: [
    {
      key: 'facebook',
      url: 'https://www.facebook.com/pixartprinting.it/',
    },
    {
      key: 'instagram',
      url: 'https://www.instagram.com/pixartprinting/',
    },
    {
      key: 'linkedin',
      url: 'https://www.linkedin.com/company/pixartprinting/',
    },
  ],
  terms: [
    {
      key: 'privacy-policy',
      url: 'https://www.pixartprinting.nl/privacy/',
    },
  ],
  shopLinks: [
    {
      label: 'Online drukkerij',
      url: 'https://www.pixartprinting.nl/',
    },
    {
      label: 'Visitekaartjes',
      url: 'https://www.pixartprinting.nl/visitekaartjes/',
    },
    {
      label: 'Leaflets en flyers',
      url: 'https://www.pixartprinting.nl/klein-drukwerk/printen-flyers/',
    },
    {
      label: 'Etiketten drukken',
      url: 'https://www.pixartprinting.nl/printen-etiketten-labels/',
    },
    {
      label: 'Stickers drukken',
      url: 'https://www.pixartprinting.nl/printen-etiketten-labels/stickers/',
    },
    {
      label: 'Verpakkingen',
      url: 'https://www.pixartprinting.nl/verpakkingen/',
    },
    {
      label: 'Kartonnen doosjes',
      url: 'https://www.pixartprinting.nl/verpakkingen/standaardverpakkingen/',
    },
    {
      label: 'Shopping bags',
      url: 'https://www.pixartprinting.nl/gepersonaliseerde-tassen/',
    },
    {
      label: 'Tijdschriften, boeken, catalogi',
      url: 'https://www.pixartprinting.nl/printen-tijdschriften-boeken-catalogi/',
    },
    {
      label: 'Afdrukken op canvas',
      url: 'https://www.pixartprinting.nl/fotoproducten/print-op-canvas/',
    },
    {
      label: 'Gadgets',
      url: 'https://www.pixartprinting.nl/gepersonaliseerde-gadgets/',
    },
    {
      label: "Kalenders en agenda's",
      url: 'https://www.pixartprinting.nl/kalenders/',
    },
  ],
}
